module.exports = __webpack_public_path__ + "img/LAL_login_btn_LS.b374e541.svg";